import Route from '@ember/routing/route';
import { useQuery } from 'glimmer-apollo';
import { NEWS_POST_QUERY } from 'embroil/gql/queries/news-post';
import { service } from '@ember/service';

export default class Post extends Route {
  @service head;

  async model({ slug }) {
    try {
      this.data = useQuery(this, () => [
        NEWS_POST_QUERY,
        { variables: { slug } },
      ]);

      await this.data.promise;
      
      // Combine different article types for mixed popular posts
      const popularPosts = [
        ...(this.data.data.popularGameArticles || []),
        ...(this.data.data.popularEsportsArticles || [])
      ];
      
      // New GraphQL API returns direct object, not collection/items structure
      return {
        article: this.data.data.article,
        popularPosts: popularPosts
      };
    } catch (error) {
      console.error('Error loading news post:', error);
      // Redirect to 404 or return null to show error page
      this.replaceWith('404');
      return null;
    }
  }

  afterModel(model) {
    if (model && model.article) {
      this.head.updateMeta({
        title: model.article.title,
        description: model.article.shortDescription,
        ogTitle: model.article.title,
        ogDescription: model.article.shortDescription,
        ogImage: model.article.coverImage.url,
        ogType: 'article',
        canonical: `https://1vX.gg/news/${model.article.slug}`
      });
    }
  }
}
